import { ramses } from '../api'
import BaseFetch from './base'

export default class Ramses extends BaseFetch {
    api = ramses
}
